<template>
    <div v-click-outside="hidePicker">

        <tooltip
            :disabled="showPicker"
            :content="$t('general.add_variables')"
            offset="0,8"
        >
            <editor-button :active="showPicker" @click="togglePicker" ref="button">
                <svg-icon type="insert-text" class="w-24 h-24"></svg-icon>
            </editor-button>
        </tooltip>

        <div ref="picker" class="z-top">
            <transition name="fade">
                <keep-alive>
                    <placeholder-picker :categories="categories" v-if="showPicker" @select="handleSelect"></placeholder-picker>
                </keep-alive>
            </transition>
        </div>
    </div>
</template>

<script>
import PlaceholderPicker from '../forms/PlaceholderPicker.vue';
import SvgIcon from './SvgIcon.vue';
import EditorButton from './EditorButton.vue';
import clickOutside from '../../mixins/clickOutside';
import { createPopper } from '@popperjs/core';
import Tooltip from '../navigation/Tooltip.vue';

export default {
    components: {
        'placeholder-picker': PlaceholderPicker,
        'svg-icon': SvgIcon,
        'editor-button': EditorButton,
        'tooltip': Tooltip,
    },
    props: {
        categories: {
            type: Array,
            required: true,
        }
    },
    mixins: [
        clickOutside
    ],
    data: function () {
        return {
            showPicker: false,
        }
    },
    methods: {
        togglePicker () {
            this.showPicker = !this.showPicker;

            if (this.showPicker) {
                this.updatePopper();
            }
        },
        createPopper () {
            this._popper = createPopper(this.$refs.button.$el, this.$refs.picker, {
                placement: 'top',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0,4],
                        }
                    }
                ]
            });
        },
        updatePopper () {
            this._popper ? this._popper.update() : this.createPopper();
        },
        handleSelect (placeholder) {
            this.$emit('select', placeholder);
            this.hidePicker();
        },
        hidePicker () {
            this.showPicker = false;
        }
    }
}
</script>
